import React from "react";

export const DropdownIcon = () => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2862_11314)">
      <path fillRule="evenodd" clipRule="evenodd" d="M16.6922 8.44219L10.4422 14.6922C10.325 14.8095 10.1659 14.8755 10 14.8755C9.83412 14.8755 9.67504 14.8095 9.55781 14.6922L3.30781 8.44219C3.0636 8.19797 3.0636 7.80203 3.30781 7.55781C3.55203 7.3136 3.94797 7.3136 4.19219 7.55781L10 13.3664L15.8078 7.55781C16.052 7.3136 16.448 7.3136 16.6922 7.55781C16.9364 7.80203 16.9364 8.19797 16.6922 8.44219V8.44219Z" fill="#0F1417"/>
    </g>
    <defs>
      <clipPath id="clip0_2862_11314">
        <rect width="20" height="20" fill="white" transform="translate(0 0.5)"/>
      </clipPath>
    </defs>
  </svg>
);

export const DropupIcon = () => (
  <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2862_11305)">
      <path fillRule="evenodd" clipRule="evenodd" d="M16.6922 11.0578L10.4422 4.80781C10.325 4.69045 10.1659 4.62451 10 4.62451C9.83412 4.62451 9.67504 4.69045 9.55781 4.80781L3.30781 11.0578C3.0636 11.302 3.0636 11.698 3.30781 11.9422C3.55203 12.1864 3.94797 12.1864 4.19219 11.9422L10 6.13359L15.8078 11.9422C16.052 12.1864 16.448 12.1864 16.6922 11.9422C16.9364 11.698 16.9364 11.302 16.6922 11.0578V11.0578Z" fill="#0F1417"/>
    </g>
    <defs>
      <clipPath id="clip0_2862_11305">
        <rect width="20" height="19" fill="white" transform="matrix(1 0 0 -1 0 19)"/>
      </clipPath>
    </defs>
  </svg>
);
